import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Layout, App as AntdApp } from 'antd'
import AppHeader from './components/Layout/AppHeader'
import AppFooter from './components/Layout/AppFooter'
import Home from './pages/Home'
import Chat from './pages/Chat'
import Textbook from './pages/Textbook'
import Diagnosis from './pages/Diagnosis'
import Tools from './pages/Tools'
import Knowledge from './pages/Knowledge'
import Herbs from './pages/Herbs'
import About from './pages/About'
import Auth from './pages/Auth'
import Profile from './pages/Profile'
import RuoyiAdminRedirect from './pages/RuoyiAdminRedirect'
import './App.css'

const { Content } = Layout

const AppContent: React.FC = () => {
  const location = useLocation()
  const isChatPage = location.pathname === '/chat'
  const isAuthPage = location.pathname.startsWith('/auth')
  const isAdminPath =
    location.pathname === '/admin' || location.pathname.startsWith('/admin/')

  // 若依管理端子路径：客户端路由进入时整页重载以走代理（见 RuoyiAdminRedirect）
  if (isAdminPath) {
    return (
      <Routes>
        <Route path="/admin/*" element={<RuoyiAdminRedirect />} />
      </Routes>
    )
  }

  // 登录页面使用独立布局
  if (isAuthPage) {
    return (
      <Routes>
        <Route path="/auth/*" element={<Auth />} />
      </Routes>
    )
  }

  return (
    <Layout className="min-h-screen">
      <AppHeader />
      <Content className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/knowledge" element={<Knowledge />} />
          <Route path="/knowledge/herbs" element={<Herbs />} />
          <Route path="/textbook/*" element={<Textbook />} />
          <Route path="/diagnosis/*" element={<Diagnosis />} />
          <Route path="/tools/*" element={<Tools />} />
          <Route path="/about" element={<About />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </Content>
      {!isChatPage && <AppFooter />}
    </Layout>
  )
}

const App: React.FC = () => {
  return (
    <AntdApp>
      <AppContent />
    </AntdApp>
  )
}

export default App

